export const parseClipboard = (text: string): string[][] =>
  text
    .split('\n')
    .filter(Boolean)
    .map(line =>
      line
        .split('\t')
        .map(cell => cell.trim().replace(/,/g, '').replace(/\s+/g, ''))
        .filter(cell => cell !== '' && parseFloat(cell) !== 0)
    )
    .filter(row => row.length > 0)
